<div class="w-full h-screen bg-group-invite bg-cover place-content-center">

    <app-open-banner class="fixed top-0 left-0 w-full z-50" [path]="appDeepLinkPath"></app-open-banner>

    <div class="hidden md:block flex-row lg:w-2/3 h-1/2 justify-center place-content-center mx-16 lg:mx-auto">

        <div class="flex flex-row w-full justify-center content-center">

            <div class="w-full">
                <div class="mb-8">
                    <a href="https://atchurch.app"><img class="h-14"
                            src="assets/brand/atc_full_whiteOnTransparent.png" />
                    </a>
                </div>
                <p class="text-md capitalize text-white mb-2">
                    You've been Invited to
                </p>
                <p class="text-2xl font-semibold capitalize text-white mb-2">
                    {{ event?.name ?? 'an Event' }}
                </p>
                <p class="text-md font-light text-white mb-4">
                    on the AtChurch App
                </p>
                <button type="button"
                    class="rounded-full text-md px-6 py-2.5 bg-gray-100 text-primary shadow hover:bg-secondary-500 hover:text-white hover:shadow-lg"
                    (click)="openInApp()">
                    <i class="fa fa-circle-arrow-right mr-2"></i>View in App</button>
            </div>

            <div class="w-full">
                @if (event?.bannerImage) {
                <div class="rounded mb-4 mx-2">
                    <img alt="..." [src]="event?.bannerImage"
                        class="bg-gray-100 shadow-xl rounded w-full object-cover mx-auto align-middle border-none max-h-[250px]" />
                </div>
                } @else {
                <div
                    class="bg-gray-100 mb-4 uppercase text-primary-500 text-4xl flex justify-center items-center text-center h-64 w-128 rounded">
                    {{ event?.name | initials }}
                </div>
                }
                @if (event) {
                <p class="text-2xl text-center font-semibold capitalize text-white mb-4">
                    {{event.name}}
                </p>
                <p class="text-md text-center font-light text-white mb-2">
                    {{ event.startDateTime.toDate() | moment: 'ddd MMM D, YYYY hh:mm a' }}
                </p>
                @if (event.location?.name) {
                <p class="text-md text-center font-light text-white mb-4">
                    {{event.location?.name}}
                </p>
                }
                @if (event.description) {
                <p class="text-md text-center font-light text-white mb-4">
                    {{event.description}}
                </p>
                }
                } @else if (!loading) {
                <p class="text-md text-center font-light text-white mb-4">
                    Open the AtChurch app to see the full event details.
                </p>
                }
            </div>
        </div>
    </div>

    <div class="block md:hidden flex-col justify-center place-items-center w-full mx-auto px-4 py-8">

        <div class="w-full mb-6">
            <a href="https://atchurch.app"><img class="h-10 mx-auto"
                    src="assets/brand/atc_full_whiteOnTransparent.png" />
            </a>
        </div>

        <p class="text-md text-center font-light text-white mb-1">
            You've been Invited to
        </p>
        <p class="text-2xl font-semibold text-center capitalize text-white mb-1">
            {{ event?.name ?? 'an Event' }}
        </p>
        <p class="text-md text-center font-light text-white mb-4">
            on the AtChurch App
        </p>
        @if (event?.bannerImage) {
        <div class="rounded mb-4 mx-2 shadow-lg">
            <img alt="..." [src]="event?.bannerImage"
                class="shadow-xl rounded w-full object-cover mx-auto align-middle border-none max-h-[250px]" />
        </div>
        }
        <div class="text-center mb-4">
            <button type="button"
                class="rounded-full text-md px-4 py-2 bg-gray-100 text-primary shadow hover:bg-secondary-500 hover:text-white hover:shadow-lg"
                (click)="openInApp()">
                <i class="fa fa-circle-arrow-right mr-2"></i>View in App</button>
        </div>
        @if (event) {
        <p class="text-md text-center font-light text-white mb-2">
            {{ event.startDateTime.toDate() | moment: 'ddd MMM D, YYYY hh:mm a' }}
        </p>
        @if (event.location?.name) {
        <p class="text-md text-center font-light text-white mb-2">
            {{event.location?.name}}
        </p>
        }
        @if (event.description) {
        <p class="text-md text-center font-light text-white mb-4">
            {{event.description}}
        </p>
        }
        } @else if (!loading) {
        <p class="text-md text-center font-light text-white mb-4">
            Open the AtChurch app to see the full event details.
        </p>
        }

    </div>

    <div class="absolute bottom-1 w-full center">
        <p class="text-xs text-gray-400 text-center px-4 py-1">
            Background Photo by <a
                href="https://unsplash.com/@kirp?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Andrew
                Kliatskyi</a> on <a
                href="https://unsplash.com/photos/background-pattern-r4HT6aurLQw?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
        </p>
    </div>
</div>
